import { Component, OnInit, ViewChild } from "@angular/core";
import { UserService } from "../services/user.service";
import { Router } from "@angular/router";
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";

import {
  MatAutocompleteSelectedEvent,
  MatDatepickerInputEvent,
  MatPaginator,
  MatSort,
  MatTableDataSource,
  MatDialog
} from "@angular/material";
import * as moment from "moment";
import { ProperJsonDialogComponent } from '../properJsonDialog/properjsondialog.component';
import { TableUtil } from "../admintrademaster/tableUtil";
import { NotificationsService } from "angular2-notifications";

@Component({
  selector: "app-payout",
  templateUrl: "./payout-customers.component.html",
  styleUrls: ["./payout-customers.component.css"],
})
export class PayoutCustomersComponent implements OnInit {
  _csrf: string;
  dataSource = new MatTableDataSource<any>([]);
  filteredDataSource = new MatTableDataSource<any>([]);
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  request_id: string = "";
  oPayouts: any = [];
  payouts: any = [];
  oPayoutRows: any = [];
  rowStatus: string = "";
  payoutRows: any = [];
  filter: any = {
    page: 1,
    limit: 15,
    fromDate: moment().subtract(3, "d").format("YYYY-MM-DD"),
    toDate: moment().format("YYYY-MM-DD"),
  };
  prev_disabled = true;
  next_disabled = false;
  rows_prev_disabled = true;
  rows_next_disabled = false;

  constructor(
    private router: Router,
    private notifSer: NotificationsService,
    private userService: UserService,
    private spinnerService: Ng4LoadingSpinnerService,
    public dialog: MatDialog
  ) { }

  ngOnInit() {
    this.csrf();
  }

  csrf() {
    this.userService.csrf().subscribe(
      (success) => {
        this._csrf = success._csrf;
        this.getData();
      },
      (error) => {
        this.notifSer.error("Error", error.error.message, {
          timeOut: 3000,
          showProgressBar: true,
          pauseOnHover: false,
          clickToClose: true,
          maxLength: 50,
        });
      }
    );
  }

  goNext(type = 1) {
    if (type == 1) {
      this.filter.page++;
      this.getData();
    } 
  }

  goPrev(type = 1) {
    if (type == 1) {
      if (this.filter.page > 1) {
        this.filter.page--;
        this.getData();
      }
    }
  }

  goBack() {
    this.request_id = "";
    this.payoutRows = [];
  }

  fromDateFilter(event: MatDatepickerInputEvent<Date>, type: Number = 1) {
    if (event.value) {
      console.log(event.value, "event value");
      if (type == 1) {
        this.filter["fromDate"] = moment(event.value).format("YYYY-MM-DD");
      } 
    }
  }

  toDateFilter(event: MatDatepickerInputEvent<Date>) {
    if (event.value) {
      this.filter["toDate"] = moment(event.value).format("YYYY-MM-DD");
    }
  }

  applyFilter(filterValue: string): void {
    if (filterValue) {
      this.payouts = this.payouts.filter((x: any) => {
        return x.request_id.toLowerCase().includes(filterValue.toLowerCase());
      });
    } else {
      console.log("else called");
      this.payouts = this.oPayouts;
    }
  }

  getData() {
    this.spinnerService.show();
    this.filter._csrf = this._csrf;
    this.userService.getPayoutCustomers(this.filter).subscribe((list: any) => {
      this.payouts = list;
      this.oPayouts = list;
      this.spinnerService.hide();
      if (this.filter.page <= 1) {
        this.prev_disabled = true;
      } else {
        this.prev_disabled = false;
      }
      if (!list || list.length < this.filter.limit) {
        this.next_disabled = true;
      }
    });
  }

  displayProperJson(jsonData, eventType) {
    console.log(jsonData, eventType, "jsonData in payout customers");
    let obj = {
      jsonData: jsonData,
      eventType: eventType || "Payout Custoemer"
    }
    this.dialog.open(ProperJsonDialogComponent, {
      width: 'auto',
      height: 'auto',
      data: obj,
    }).afterClosed().subscribe(result => {
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/payout-customers/payout-customers.component.ts